import http from '../utils/fetch';
export default {
    query(query) {
        return http({
            url: '/api/task/listpage',
            method: 'post',
            params: query
        });
    },
    searchMyUndoTask(query) {
        return http({
            url: '/api/task/searchMyUndoTask',
            method: 'post',
            params: query
        });
    },
    searchMyUndoTaskPage(query) {
        return http({
            url: '/api/task/searchMyUndoTaskPage',
            method: 'post',
            params: query
        });
    },
    deleteTask(taskId) {
        return http({
            url: '/api/task/deleteTaskById',
            method: 'post',
            params: {taskId}
        });
    },
    getTaskByTaskid(taskid) {
        return http({
            url: '/api/task/getTaskByTaskid',
            method: 'post',
            params: {taskid}
        });
    },
    queryCount(query) {
        return http({
            url: '/api/task/queryCount',
            method: 'post',
            params: query
        });
    },
    listHistoryByTaskid(taskid){
        return http({
            url: '/api/task/listHistoryByTaskid',
            method: 'post',
            params:{taskid}
        });
    },
    listHistoryByInstid(instid){
        return http({
            url: '/api/task/listHistoryByInstid',
            method: 'post',
            params:{instid}
        });
    },

    selectByInstid(query){
        return http({
            url: '/api/task/selectByInstid',
            method: 'post',
            params: query
        });
    },
    //测试用的--------》
    start(){
        return http({
            url: '/api/process/testProgress/start',
            method: 'post'
        });
    },
    complete(q){
        return http({
            url: '/api/process/testProgress/complete',
            method: 'post',
            params: q
        });
    },
    //定时任务手动执行
    runtaskByKey(key){
        return http({
            url: '/api/swyl/v1/basic/task/runtask',
            method: 'get',
            params: {task:key}
        });
    },
    savebeizhu(v){
        return http({
            url: '/api/task/savebeizhu',
            method: 'post',
            params: v
        });
    },

    runtaskBtn(key){
        return http({
            url: '/api/swyl/v1/inf/searchAndInit/bimproductprice',
            method: 'post',
            params: {materialid:key}
        });
    },
}
